module.exports = __webpack_public_path__ + "img/huawei-p9-lite.d6eb62f2.png";